import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import { USER_ROLE } from '@/shared/constants';

import MainLayout from '@/shared/components/layout/MainLayout';
import PageWrapper from './PageWrapper';

const ParentHomePage = lazy(() => import('@/pages/parent/home/Page'));
const ParentAttendancePage = lazy(() => import('@/pages/parent/attendance/Page'));

const ParentMyClassPage = lazy(() => import('@/pages/parent/my-class/Page'));
const SelectStudentPage = lazy(() => import('@/pages/parent/select-student/Page'));

/**
 * student/parent는 capacitor-gate-erp의 라우트 구성을 기준으로 삼는다.
 * gate-erp에 있던 lesson/activities/feedback/report-card/notice 라우트는 capacitor에 없는
 * 화면이라 일단 연결을 끊었다 — 페이지 파일 자체는 지우지 않았으니 필요해지면 다시 연결하면 된다.
 */
export const parentRoutes: RouteObject = {
  path: '/parent',
  element: <AuthRoute allowedRoles={[USER_ROLE.PARENT]} />,
  children: [
    // MainLayout 밖에 둔다 — 자녀 선택 전이라 상단바/하단탭바 없이 전체 화면으로 보여준다
    {
      path: 'select-student',
      element: (
        <PageWrapper>
          <SelectStudentPage />
        </PageWrapper>
      ),
    },
    {
      element: <MainLayout />,
      children: [
        { index: true, element: <Navigate to='home' replace /> },
        {
          path: 'home',
          element: (
            <PageWrapper>
              <ParentHomePage />
            </PageWrapper>
          ),
        },
        {
          path: 'attendance',
          element: (
            <PageWrapper>
              <ParentAttendancePage />
            </PageWrapper>
          ),
        },
        {
          path: 'my-class',
          element: (
            <PageWrapper>
              <ParentMyClassPage />
            </PageWrapper>
          ),
        },
      ],
    },
  ],
};
